import { render, staticRenderFns } from "./selectFoodModal.vue?vue&type=template&id=6e6926ba&scoped=true&"
import script from "./selectFoodModal.vue?vue&type=script&lang=js&"
export * from "./selectFoodModal.vue?vue&type=script&lang=js&"
import style0 from "./selectFoodModal.vue?vue&type=style&index=0&id=6e6926ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6926ba",
  null
  
)

export default component.exports